import { NodeTagsFormValues } from "@features/administration/products/EditProduct/NodeTagsForm/NodeTagsForm"
import { csvContentToRows } from "@utils/file"

export type NodeTagType = "text" | "dropdown"

export interface NodeTagRow {
  Name: string
  Type: NodeTagType
  Value: string
  Description?: string
}

export const TAG_FILE_REQUIRED_HEADERS = ["Name", "Type", "Value"]
export const TAG_FILE_HEADERS = [...TAG_FILE_REQUIRED_HEADERS, "Description"]
export const TAG_TYPE_OPTIONS = [
  { label: "text", value: "text" },
  { label: "dropdown", value: "dropdown" },
]

export const getRowsFromTagsFileContent = (csvContent: string): NodeTagRow[] => {
  const rows = csvContentToRows(csvContent)

  const headers = rows[0]?.split(",")
  if (!headers) return []

  const requiredColumnsMissing =
    new Set(TAG_FILE_REQUIRED_HEADERS).difference(new Set(headers)).size > 0
  if (requiredColumnsMissing) return []

  const typeIndex = headers.indexOf("Type")
  const nameIndex = headers.indexOf("Name")
  const valueIndex = headers.indexOf("Value")
  const descriptionIndex = headers.indexOf("Description")
  const newRows: NodeTagRow[] = []
  rows.forEach((row, index) => {
    if (index === 0) return
    const arr = row.split(",")
    newRows.push({
      Name: arr[nameIndex] ?? "",
      Value: arr[valueIndex] ?? "",
      Type: (arr[typeIndex] as NodeTagType) ?? "dropdown",
      Description: arr[descriptionIndex] ?? "",
    })
  })
  return newRows
}

export const formValuesToNodeTagsFileContent = (formValues: NodeTagsFormValues) => {
  let value = "Type,Name,Value,Description\n"
  formValues.rows.forEach((row, index) => {
    value += `${row.type},${row.name},${row.value},${row.description}`
    if (index !== formValues.rows.length - 1) value += "\n"
  })

  return value
}

export type NodeTagsMap = Map<
  string,
  {
    options: {
      value: string
      description: string
    }[]
    type: NodeTagType
  }
>

export const getNodeTagsMap = (csvContent: string) => {
  const rows = getRowsFromTagsFileContent(csvContent)
  const tagsMap: NodeTagsMap = new Map()

  rows.forEach((row) => {
    const existingEntry = tagsMap.get(row.Name)

    if (!existingEntry) {
      tagsMap.set(row.Name, {
        options: [{ value: row.Value, description: row.Description ?? "" }],
        type: row.Type,
      })
    } else {
      tagsMap.set(row.Name, {
        options: [
          ...existingEntry.options,
          { value: row.Value, description: row.Description ?? "" },
        ],
        type: existingEntry.type,
      })
    }
  })

  return tagsMap
}
